import React, { Fragment, useState } from 'react';
import { Grid, FormControlLabel, RadioGroup, Radio, Typography, Box } from '@material-ui/core';
import { useStyle } from './style';

const greyLayout = {
    borderColor: 'darkgrey',
};
const purpleLayout = {
    borderColor: 'purple',
};

export const EirCheckoutHeader = props => {
    const classes = useStyle();
    const { customerType, setCustomerType } = props;
    const [registeredLayout, setRegisteredLayout] = useState(purpleLayout);
    const [guestLayout, setGuestLayout] = useState(greyLayout);

    const handleChange = event => {
        setCustomerType(event.target.value);

        if (event.target.value === 'guest') {
            setGuestLayout(event.target.checked ? purpleLayout : greyLayout);
            setRegisteredLayout(event.target.checked ? greyLayout : purpleLayout);
        } else if (event.target.value === 'registered') {
            setRegisteredLayout(event.target.checked ? purpleLayout : greyLayout);
            setGuestLayout(event.target.checked ? greyLayout : purpleLayout);
        }
    };

    return (
        <Fragment>
            <div className={classes.layout}>
                <Grid container spacing={2} className={classes.margintop}>
                    {customerType === 'guest' && (
                        <Grid item xs={12} sm={6}>
                            <Box display={{ xs: 'none', md: 'block' }}>
                                <h1 id='continue-as-a-guest' className={classes.checkoutH1}> Continue as a guest </h1>
                            </Box>
                            <Box display={{ xs: 'block', md: 'none' }}>
                                <h1 className={classes.checkoutH1}> Continue as guest </h1>
                            </Box>
                        </Grid>
                    )}
                    {customerType === 'registered' && (
                        <Grid item xs={12} sm={6}>
                            <Box display={{ xs: 'none', lg: 'block' }}>
                                <h1 id='register-as-a-new-customer' className={classes.checkoutH1}>
                                    {' '}
                                    Register as a new customer{' '}
                                </h1>
                            </Box>
                            <Box display={{ xs: 'block', lg: 'none' }}>
                                <h1 className={classes.checkoutH1}> Register </h1>
                            </Box>
                        </Grid>
                    )}

                    <Grid item xs={12} sm={6}>
                        <Grid container className={classes.marginbottom3} justify='flex-end'>
                            <Grid item>
                                <RadioGroup
                                    row
                                    name='customerType'
                                    value={customerType}
                                    onChange={handleChange}
                                >
                                    <FormControlLabel
                                        style={registeredLayout}
                                        classes={{ label: classes.label, root: classes.radioLabel }}
                                        value='registered'
                                        control={
                                            <Radio
                                                classes={{ checked: classes.checked }}
                                                color='primary'
                                            />
                                        }
                                        label={
                                            <Typography className={classes.boldFont}>
                                                Register as a new customer
                                            </Typography>
                                        }
                                    />
                                    <FormControlLabel
                                        style={guestLayout}
                                        classes={{ label: classes.label, root: classes.radioLabel }}
                                        value='guest'
                                        control={
                                            <Radio
                                                classes={{ checked: classes.checked }}
                                                color='primary'
                                            />
                                        }
                                        label={
                                            <Typography className={classes.boldFont}>
                                                Continue as a guest
                                            </Typography>
                                        }
                                    />
                                </RadioGroup>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </Fragment>
    );
};
